/**
 * @typedef {Object} BillingStatusResponseDto
 * @property {number} balance
 * @property {boolean} isNegative
 * @property {string} [negativeSinceDate]
 */

const BASE_PATH = 'v1/Billing';

export default function (instance) {
  return {
    /**
     * The caller's own org's current balance and overdraft state.
     * @returns {Promise<{data: BillingStatusResponseDto}>}
     */
    getStatus() {
      return instance.get(`${BASE_PATH}/status`);
    }
  };
}
